import { combineReducers } from 'redux';
import { ZendeskDrawerView } from '../actions/drawer';
import { PrioHealthErrorLevel, ZendeskSearchResult } from '../../../models/Zendesk';
import drawer, * as fromDrawer from './drawer';
import PrioHealthHighestErrorLevel, * as fromPrioHealthHighestErrorLevel from './prioHealthHighestErrorLevel';

export interface ZendeskReducerState {
  drawer: fromDrawer.ZendeskDrawerState;
  prioHealthHighestErrorLevel: fromPrioHealthHighestErrorLevel.PrioHealthHighestErrorLevelState;
}

export default combineReducers<ZendeskReducerState>({
  drawer,
  prioHealthHighestErrorLevel: PrioHealthHighestErrorLevel,
});

export const getDrawerOpen: (state: ZendeskReducerState) => boolean = (state) =>
  fromDrawer.getOpen(state.drawer);

export const getDrawerView: (
  state: ZendeskReducerState
) => ZendeskDrawerView = (state) => fromDrawer.getView(state.drawer);

export const getDrawerSearchResult: (
  state: ZendeskReducerState
) => ZendeskSearchResult = (state) => fromDrawer.getSearchResult(state.drawer);

export const getDrawerSearchTerm: (state: ZendeskReducerState) => string = (
  state
) => fromDrawer.getSearchTerm(state.drawer);

export const getPrioHealthHighestErrorLevel: (
  state: ZendeskReducerState
) => PrioHealthErrorLevel = (state) =>
  fromPrioHealthHighestErrorLevel.getHighestErrorLevel(
    state.prioHealthHighestErrorLevel
  );
